module.exports = __webpack_public_path__ + "img/f5db5267c24546189024eaf9774b17f5-1440.8f8e678a.jpg";